import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const SearchResultsPage = lazy(
  () =>
    import('./SearchResultsPageSwitch').then(mod => ({
      default: mod.SearchResultsPageSwitch,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
